import * as React from 'react';

const ArrowLeft = (props) => (
  <svg fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M7.542 1.4 2.108 6.833a1.655 1.655 0 0 0 0 2.333L7.542 14.6'
      stroke='#333'
      strokeWidth='1.5'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default ArrowLeft;
